module.exports = __webpack_public_path__ + "img/wxp1.a34b0d6c.png";